export const getChannelLiveUrl = (item, type = "tv") =>
  (`/${type === "channel" ? "tv" : type}/player/${item.channels_id}`);
